export const CURRENCY_USD = "usd"
export const CURRENCY_EUR = "eur"
export const CURRENCY_GBP = "gbp"
export const CURRENCY_CNY = "cny"
export const CURRENCY_JPY = "jpy"

export const GENERAL_CURRENCY = CURRENCY_EUR
